import React, { useContext } from "react";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import { modify_SlotDetails } from "../actions";
import { Context, ErrorLog } from "../store";     //FB 4487 DK - Importing ErrorLog class from store
import { useHistory } from "react-router-dom";
import globalsettings from "../../../config";
//FB-6264
//FB 7675
import { ConvertTimeZone, InsertPELogs, NotifyErrorOutage } from "../api";      //FB 4487 DK - Importing the logError method used for error logging, FB 4960

// update log
// FB 4371 DK    03/29/2021    Added UI component to display the slots
// FB 4409 DK    04/27/2021    Implementation of loading spinner on slots page
// FB 4487 DK    06/07/2021    Implemented error logging on api call failures
// FB 4556 DK    07/07/2021    Implement client side error handling on PE
// FB 4638 MS    08/31/2021    Fixed Mobile view issues
// FB 4867 DK    01/20/2022    Phone number made clickable
// FB 4960 BR    07/03/2022    Logging all actions on PE
// FB 6264 DK    11/22/2022    Migrate PE API,DB to EMR
// FB 7675 DK    11/09/2023    Timezone handling for appointments

const useStyles = makeStyles((theme) => ({
  flexRow: {
    display: "flex",
    flexDirection: "row",
  },
  container: {
    maxWidth: "10%",
    display: "flex",
    flexDirection: "column",
    alignSelf: "flex-start",
    justifyContent: "center",
  },
  containerRow: {
    display: "flex",
    flexDirection: "row",
    alignSelf: "flex-start",
    justifyContent: "center",
  },
  topBarItem: {
    alignSelf: "flex-start",
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
  },
  margin: {
    margin: "5px 5px 0 0",
  },
  timeSlotItem: {
    borderRadius: "16px",
    border: "0",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#EDEEEE",
    width: "70%",
    cursor: "pointer",
    fontSize: "smaller",
    height: "25px",
    "&:hover, &:focus": {
      backgroundColor: "#25aae1",
      color: "#fff",
    },
  },
  flexColumn: {
    display: "flex",
    flexDirection: "column",
  },
}));

//FB 4371 DK    Added fnction to save the selected slot to preregistartion table
export async function addPreRegistration(preRegObj: any) {
  //FB-6264
  const targetUrl = globalsettings.emrAPI + "api/Provider/Schedule/Preregistration/AddSlot";
  const config = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },

    body: JSON.stringify(preRegObj),
  };
  const response = await fetch(targetUrl, config);

  //FB 4487 DK - Added logic for logging the error's on API call - Start
  if (!response.ok) {
    //FB 4556 DK - Implement client side error handling on PE - Start
    //FB-6264
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    const data = await response.json();
    return data;
  }
  //FB 4487 DK - Added logic for logging the error's on API call - End
}

function SlotsByDateContainer(props: any) {
  const classes = useStyles();
  const { state, dispatch } = useContext(Context);
  const [expanded, setExpanded] = React.useState<boolean>(false);
  const [itemsToShow, setItemsToShow] = React.useState<number>(8);
  const [selectedSlot, setSelectedSlot] = React.useState<string>("");
  const history = useHistory();
  state.appointmentdetails.location.phone = props.facilityPhone.props.children[1];    //FB-4867

  //FB 4371 DK    Added to toggle show more and hide slots

  function toggle() {
    setItemsToShow(expanded ? 8 : props.schedulesTest.Slots.length);
    setExpanded(!expanded);
    //FB 4960 Start
    if (expanded) {
      InsertPELogs(globalsettings.clientIp, "Click on Show less - by Date flow for " + props.schedulesTest.ScheduleDate);
    }
    else {
      InsertPELogs(globalsettings.clientIp, "Click on Show More - by Date flow for " + props.schedulesTest.ScheduleDate);
    }
    //FB 4960 End
  }

  //FB 4371 DK    Added to book the selected slot

  function bookSlot(
    slots: any,
    scheduleDate: any,
    employeeid: any,
    facilityid: number
  ) {
    setSelectedSlot(slots);
    //FB 4960 Start
    InsertPELogs(globalsettings.clientIp, "Click on time slot " + slots);
    //FB 4960 End
  }

  //FB 4371 DK    Added to save the selected slot to preregistartion table and modify the state
  React.useEffect(() => {
    if (selectedSlot != "") {
      props.onCallback(true);
      //FB 4409 DK  Added to activate loading spinner once slot is selected
      props.isLoading(true);
      var date = new Date(
        state.appointmentdetails.date.toLocaleDateString() + " " + selectedSlot
      );
      var x = date.getTimezoneOffset();
      date.setMinutes(date.getMinutes() - x);
      const preRegistrationObj = {
        EMPLOYEE_N: props.employeeid,
        FACILITY_N: props.facilityid,
        PRE_REGISTRATION_DATE: date,
        PRE_REGISTRATION_SLOT_TIME: date,
      };
      (async () => {
        var data = await addPreRegistration(preRegistrationObj);
        if (data == 0) {
          //setOpen(true);
        } else {
          modify_SlotDetails(
            {
              employeeId: props.employeeid,
              facilityId: props.facilityid,
              id: data,
              slotDate: new Date(
                state.appointmentdetails.date.toLocaleDateString() +
                " " +
                selectedSlot
              ),
              employeeName: props.employeeName,
              facilityName: props.facilityName,
              isslotexisting: false,
            },
            dispatch
          );

          state.appointmentdetails.location.name = props.facilityName;
          state.appointmentdetails.location.address = props.facilityAddress;
          state.appointmentdetails.duration = props.duration;   //FB 4638 added appt duration      
          history.push("/demographics", state);
        }
      })();
    }
  }, [selectedSlot]);

  //FB 7675
  var timeZone = "America/Port-au-Prince";
  var userTimeZone = sessionStorage.getItem("TimeZone");
  if (userTimeZone != null) {
    timeZone = userTimeZone;
  }

  return (
    <React.Fragment>
      {props.limited === 1 ? (
        <Grid
          container
          direction="row"
          alignContent="center"
          style={{ display: "flex", flexFlow: "nowrap" }}
        >
          {props.schedulesTest.Slots.slice(0, itemsToShow).map(
            (slot: string, index: number) => {
              //FB 7675
              var convertedSlot = ConvertTimeZone(state.appointmentdetails.date.toLocaleDateString(), slot, timeZone, "time");
              return (
                <Grid
                  container
                  className={`${classes.topBarItem} ${classes.margin}`}
                  key={index}
                >
                  <div
                    className={`${classes.flexRow} ${classes.timeSlotItem}`}
                    style={{ width: "70px", height: "40px" }}
                    onClick={() =>
                      bookSlot(
                        slot,
                        state.appointmentdetails.date,
                        props.employeeid,
                        props.facilityid
                      )
                    }
                  >
                    {/* FB 7675 */}
                    {convertedSlot}
                  </div>
                </Grid>
              );
            }
          )}
          {props.schedulesTest.Slots.length < 8 ? (
            <div></div>
          ) : (
            <Grid
              container
              className={`${classes.topBarItem} ${classes.margin}`}
              style={{ paddingLeft: "10px" }}
            >
              <div
                className={`${classes.flexRow} ${classes.timeSlotItem}`}
                onClick={toggle}
                style={{ width: "70px", height: "40px" }}
              >
                {expanded ? "Show Less" : "Show More"}
              </div>
            </Grid>
          )}
        </Grid>
      ) : (
        <></>
      )}
    </React.Fragment>
  );
}

export default SlotsByDateContainer;
